import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { languages } from '../../../../configs/language'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { ScrollComponent } from '../../../common/scrollComponent'
import { SENTIMENT_TYPE, SUBJECT_TYPE } from '../../common/constant'
import { READ_STATUS, TIME_PERIOD } from '../constant'
import { selectCriteria, selectLoading } from '../store/slice'
import { Option } from './Option'
import { ResetBtn } from './ResetBtn'
import classes from './index.module.scss'

export const SideBar = () => {
  const criteria = useSelector(selectCriteria)
  const isLoading = useSelector(selectLoading('criteria'))
  const locale = useSelector((state) => state.i18n.locale)
  const filters = [
    {
      type: 'checkbox',
      filterType: 'readStatus',
      title: 'alerts.READ_OR_UNREAD',
      options: Object.values(READ_STATUS).map((item) => ({
        value: item.value,
        label: item.name,
        isI18n: true,
      })),
    },
    {
      type: 'checkbox',
      filterType: 'subjectType',
      title: 'alerts.SUBJECT_TYPE',
      options: Object.values(SUBJECT_TYPE).map((item) => ({
        value: item.id,
        label: item.name,
        isI18n: true,
      })),
    },
    {
      type: 'checkbox',
      filterType: 'sentiment',
      title: 'alerts.SENTIMENTS',
      options: Object.values(SENTIMENT_TYPE).map((item) => ({
        value: item.id,
        label: item.name,
        isI18n: true,
      })),
    },
    {
      type: 'radio',
      filterType: 'timePeriod',
      title: 'alerts.TIME_PERIOD',
      options: Object.values(TIME_PERIOD).map((item) => ({
        value: item.key,
        label: item.label,
        isI18n: true,
      })),
    },
    {
      type: 'checkbox',
      filterType: 'criteria',
      title:
        criteria.criteriaEvent?.[0]?.[
          `${locale === languages.vi ? 'groupName' : 'en_GroupName'}`
        ],
      options: criteria.criteriaEvent?.map((item) => ({
        value: item.alertCriteriaId,
        label:
          locale === languages.vi ? item.criteriaName : item.en_CriteriaName,
      })),
    },
    {
      type: 'checkbox',
      filterType: 'criteria',
      title:
        criteria.criteriaScore?.[0]?.[
          `${locale === languages.vi ? 'groupName' : 'en_GroupName'}`
        ],
      options: criteria.criteriaScore?.map((item) => ({
        value: item.alertCriteriaId,
        label:
          locale === languages.vi ? item.criteriaName : item.en_CriteriaName,
      })),
    },
    {
      type: 'checkbox',
      filterType: 'criteria',
      title:
        criteria.criteriaFinancial?.[0]?.[
          `${locale === languages.vi ? 'groupName' : 'en_GroupName'}`
        ],
      options: criteria.criteriaFinancial?.map((item) => ({
        value: item.alertCriteriaId,
        label:
          locale === languages.vi ? item.criteriaName : item.en_CriteriaName,
      })),
    },
  ]

  const renderOptions = (item) => {
    return item.options.map((option, index) => (
      <Option
        key={index}
        type={item.type}
        filterType={item.filterType}
        {...option}
      />
    ))
  }

  return (
    <Element className={classes.sideBar} style={{ backgroundColor: '#EBEBEB' }}>
      {isLoading ? (
        <Loading />
      ) : (
        <ScrollComponent>
          <Element className={classes.paddingContent}>
            <ResetBtn />

            {filters.map((item, index) => (
              <Element key={index} className="mt2">
                <Element
                  className="textUppercase fw600"
                  style={{ color: '#2B457D', marginBottom: 12 }}
                >
                  <Translate value={item.title} />
                </Element>
                <Element>{renderOptions(item)}</Element>
              </Element>
            ))}
          </Element>
        </ScrollComponent>
      )}
    </Element>
  )
}
